module.exports = __webpack_public_path__ + "static/media/story-banner.9054b5cc.png";